import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Alert } from 'react-bootstrap';
import AuthLayout from '../layouts/AuthLayout';
import GoogleLoginButton from '../components/auth/GoogleLoginButton';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const { isAuthenticated, error , user} = useAuth();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     const hasCompletedOnboarding = localStorage.getItem('onboardingCompleted') === 'true';
      
  //     if (hasCompletedOnboarding) {
  //       navigate('/dashboard');
  //     } else {
  //       // Verificar si es nuevo por alguna propiedad del user
  //       // Esto depende de cómo manejes el estado
  //       navigate('/onboarding');
  //     }
  //   }
  // }, [isAuthenticated, navigate, user]);

  return (
    <AuthLayout>
      <Card className="border-0 shadow-sm">
        <Card.Body className="p-4">
          <h2 className="text-center mb-4">¡Bienvenido!</h2>
          <p className="text-center text-muted mb-4">
            Inicia sesión para gestionar tus enlaces.
          </p>
          
          {error && (
            <Alert variant="danger" className="mb-4">
              {error}
            </Alert>
          )}

          <GoogleLoginButton />
          
          <p className="text-center text-muted small mt-4">
            Al iniciar sesión, aceptas nuestros 
            <a href="/terms" className="text-decoration-none"> Términos de servicio</a> y 
            <a href="/privacy" className="text-decoration-none"> Política de privacidad</a>
          </p>
        </Card.Body>
      </Card>
    </AuthLayout>
  );
};

export default LoginPage;